export default (params) => ({
  trigger: {
    name: 'content_blocks.product_row.click_reviews_in_product_row',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'personalized_assortment',
          'recently_viewed',
          'bestsellers',
          'featured_items',
          'related_products',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'read_reviews',
    },
  },
});
